import React, { useState, useEffect } from 'react';
import { School, Group } from '@mui/icons-material';
import { Card, CardContent, Grid, Typography, Tooltip, IconButton, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { BigPlayButton, ControlBar, Player, Shortcut } from 'video-react';

// ==============================|| DEFAULT DASHBOARD ||============================== //

const useStyles = makeStyles((theme) => ({
    curso: {
        backgroundColor: theme.palette.secondary[800]
    },
    grupo: {
        borderRadius: '8px',
        color: theme.palette.primary.light,
        backgroundColor: theme.palette.secondary[800]
    }
}));

const Video = ({ permiso, usuario, data, onClickFinalizar, soloLectura, ...props }) => {
    const classes = useStyles();
    const [termina, setTermina] = useState(false);
    const video = data?.video;

    const shortCut = [
        { keyCode: 39, ctrl: false, handle: () => {} },
        { keyCode: 37, ctrl: false, handle: () => {} },
        { keyCode: 74, ctrl: false, handle: () => {} },
        { keyCode: 75, ctrl: false, handle: () => {} },
        { keyCode: 76, ctrl: false, handle: () => {} }
    ];

    const finalizar = () => {
        onClickFinalizar({
            tipo: data.tipo,
            idDetalleActividad: data.idDetalleActividad,
            idColaborador: data.idColaborador,
            idActividad: data.idActividad,
            idTemario: data.idTemario,
            idSesion: data.idSesion,
            idCurso: data.idCurso
        });
    };

    const desbloquea = () => {
        setTermina(true);
    };

    return (
        <Grid container spacing={5}>
            <Grid item xs={12}>
                <Player
                    disableCompletely={data?.idCalificacionDetalle == null}
                    playsInline
                    poster="/assets/poster.png"
                    src={video?.linkVideo}
                    onEnded={desbloquea}
                >
                    <Shortcut shortcuts={shortCut} />
                    <BigPlayButton position="center" />
                    <ControlBar disableCompletely={data?.idCalificacionDetalle == null} />
                </Player>
            </Grid>
            {!soloLectura && (data?.idCalificacionDetalle != null || termina == true) && (
                <Grid item xs={12} display="flex" justifyContent="end">
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: '#003764', color: '#FFFFFF', borderRadius: '0px' }}
                        onClick={finalizar}
                    >
                        Terminado
                    </Button>
                </Grid>
            )}
        </Grid>
    );
};

export default Video;
